import PageManager from './page-manager.js';
import i18nInstance from '../utils/i18n-utils.js';
import TemplateUtils from '../utils/template-utils.js';
import Header from '../ui/header.js';
import { log } from '../utils/log-utils.js';
import Config from './config.js';

const APP_CORE_ID = 'AppCore';

class AppCore {
    constructor() {
        this.version = '2.0.0';
        this.pageManager = new PageManager();
        this.i18n = i18nInstance;
        this.templates = TemplateUtils;
        this.header = new Header();

        if (typeof window !== 'undefined') {
            window.FileToQR = this;
            window.FileToQR.pageManager = this.pageManager;
            window.FileToQR.i18n = this.i18n;

            // 언어 변경 이벤트 수신 시 전체 UI 재렌더링
            window.addEventListener('languageChanged', async () => {
                log(APP_CORE_ID, 'Language changed, re-rendering all components...');
                this.renderCommonUI();
                const currentPageId = this.pageManager.getCurrentPageId();
                // 페이지 콘텐츠 강제 재초기화
                await this.pageManager.initPage(currentPageId, true);
            });
        }
    }

    async init() {
        log(APP_CORE_ID, `FileToQR application initialization started (v${this.version})`);

        await this.i18n.init({ useSavedLang: true, detectBrowserLang: true });
        this.templates.init();
        
        this.renderCommonUI();

        const currentPageId = this.pageManager.getCurrentPageId();
        await this.pageManager.initPage(currentPageId);

        log(APP_CORE_ID, 'Application initialization successfully completed');
    }

    renderCommonUI() {
        this.templates.init();
        const headerPlaceholder = document.getElementById('header-placeholder');
        const footerPlaceholder = document.getElementById('footer-placeholder');

        if (!headerPlaceholder || !footerPlaceholder) {
            log(APP_CORE_ID, 'Header or footer placeholder not found.', 'warn');
            return;
        }

        try {
            const currentLangCode = this.i18n.currentLanguage;
            const supportedLangs = Config.LANGUAGE_CONFIG.supportedLanguages;
            const langNames = this.i18n.translations?.common?.language || {};
            const languages = supportedLangs.map(code => ({
                code,
                name: langNames[code] || code,
                url: `${window.location.pathname}?lang=${code}`,
                active: code === currentLangCode
            }));

            const currentLang = languages.find(lang => lang.code === currentLangCode);

            const context = {
                pageId: this.pageManager.getCurrentPageId(),
                basePath: window.FileToQR_Config?.basePath || '',
                t: this.i18n.t.bind(this.i18n),
                languages,
                currentLang,
            };

            const headerHtml = this.templates.render('/components/partials/header.hbs', context);
            const footerHtml = this.templates.render('/components/partials/footer.hbs', context);

            headerPlaceholder.innerHTML = headerHtml;
            footerPlaceholder.innerHTML = footerHtml;

            this.header.init();
            this.updateUIForLanguage();

        } catch (error) {
            log(APP_CORE_ID, `Failed to render common UI: ${error}`, 'error');
        }
    }

    updateUIForLanguage() {
        this.header.activateNavLinks();
    }
}

export default AppCore;



